import { main } from "assets/jss/material-kit-pro-react.jsx";

const sectionsPageStyle = {
  main: {
    ...main
  }
};

export default sectionsPageStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/views/sectionsPageStyle.jsx